"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_FONT = '400 13px/16px "Open Sans", sans-serif';
exports.BASE_FONT_FAMILY = '"Open Sans", sans-serif';
exports.BASE_FONT_LIGHTER_WEIGHT = '200';
exports.BASE_FONT_NORMAL_WEIGHT = '400';
exports.BASE_FONT_SEMI_BOLD_WEIGHT = '600';
exports.BASE_FONT_BOLD_WEIGHT = '700';
exports.FONT_SIZE_S = '12px';
exports.FONT_SIZE_M = '13px';
exports.FONT_SIZE_L = '15px';
exports.FONT_SIZE_XL = '21px';
exports.FONT_LINE_HEIGHT_S = '14px';
exports.FONT_LINE_HEIGHT_M = '16px';
exports.FONT_LINE_HEIGHT_L = '18px';
exports.FONT_LINE_HEIGHT_XL = '26px';
exports.SIZE_XXS = '2px';
exports.SIZE_XS = '4px';
exports.SIZE_S = '8px';
exports.SIZE_M = '16px';
exports.SIZE_L = '24px';
exports.SIZE_XL = '32px';
exports.SIZE_XXL = '48px';
exports.SIZE_XXXL = '64px';
exports.SPACING_XXS = '2px';
exports.SPACING_XS = '4px';
exports.SPACING_S = '8px';
exports.SPACING_M = '16px';
exports.SPACING_L = '24px';
exports.SPACING_XL = '32px';
exports.SPACING_XXL = '48px';
exports.SPACING_XXXL = '64px';
exports.FIELD_XXS = '80px';
exports.FIELD_XS = '128px';
exports.FIELD_S = '176px';
exports.FIELD_M = '272px';
exports.FIELD_L = '368px';
exports.FIELD_XL = '464px';
exports.FIELD_XXL = '560px';
exports.FIELD_NORMAL = '169px';
exports.FIELD_FULL = '100%';
exports.BASE_BORDER_WIDTH = '1px';
exports.SHADOWS_NONE = 'none';
exports.SHADOWS_NORMAL_BLUR_RADIUS = 5;
exports.SHADOWS_NORMAL = "2px 2px " + exports.SHADOWS_NORMAL_BLUR_RADIUS + "px rgba(0, 0, 0, 0.2)";
exports.MIN_CELL_WIDTH = parseInt(exports.SPACING_XL, 10) + parseInt(exports.SPACING_S, 10);
exports.GRID_TOGGLE_BUTTON_WIDTH = parseInt(exports.SPACING_XL, 10);
exports.MODAL_ZINDEX = 999;
//# sourceMappingURL=const.js.map